import "./modePro.css";
import { useAuthValue } from "./AuthContext";
import { ref, set, get, getDatabase, child } from "firebase/database";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ModePro() {
	const navigate = useNavigate();
	const { currentUser } = useAuthValue();
	const uid = currentUser.uid;
	const db = ref(getDatabase());
	const [userData, setUserData] = useState(null);
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [tr_ele_dom, setTrEleDom] = useState(false);
	const [tr_ele_ind, setTrEleInd] = useState(false);
	const [tr_air_aco, setTrAirAco] = useState(false);
	const [tr_ref_ind, setTrRefInd] = useState(false);
	const [tr_mec_aut, setTrMecAut] = useState(false);
	const [tr_ele_aut, setTrEleAut] = useState(false);
	const [request_s_air, setRequestSAir] = useState(false);
	const [request_s_ele, setRequestSEle] = useState(false);
	const [request_s_mcn, setRequestSMcn] = useState(false);
	const [showSuccessMessage, setShowSuccessMessage] = useState(false);
	const [error, setError] = useState("");

	const validateTerms = () => {
		let isValid = true;
		if (!termsAccepted) {
			isValid = false;
			setError("Debe aceptar los terminos y condiciones");
		}
		return isValid;
	};

	useEffect(
		() => {
			get(child(db, `users/${uid}`)).then(snapshot => {
				const datos = snapshot.val();
				const userData = {
					name: datos.name,
					email: datos.email,
					phone: datos.phone
				};
				setUserData(userData); // Actualiza el estado con los datos obtenidos
			});
		},
		[db, uid]
	); // Usa useEffect() para ejecutar get() cuando cambien db o uid

	if (!userData) {
		return <p>Cargando datos...</p>; // Muestra un mensaje de carga mientras se obtienen los datos
	}

	const create = e => {
		e.preventDefault();
		setError("");
		if (validateTerms()) {
			const expertData = {
				id: uid,
				name: userData.name,
				phone: userData.phone,
				email: userData.email,
				tr_ele_dom,
				tr_ele_ind,
				tr_air_aco,
				tr_ref_ind,
				tr_mec_aut,
				tr_ele_aut,
				request_s_air,
				request_s_ele,
				request_s_mcn,
				verified: false,
				ratings: "0",
				earnings: "0"
			};

			set(child(db, `experts/${uid}`), expertData);

			setShowSuccessMessage(true);

			setTimeout(() => {
				navigate("/");
			}, 3000);
		}
	};

	return (
		<div className="center">
			{showSuccessMessage
				? <div>
						<p>Perfil creado con éxito</p>
						<p>Redirigiendo a la página principal...</p>
					</div>
				: <div className="modePro">
						<div>
							<img src="logo.png" alt="Logo" width={300} />
						</div>
						<div>
							<h1
								style={{ fontSize: 26, color: "#03a99f", fontWeight: "bold" }}
							>
								Perfil Profesional
							</h1>
						</div>
						<div>
							<p style={{ fontSize: 14, color: "#03a99f" }}>
								<strong>Nombre: </strong>
								{userData.name}
							</p>
							<p style={{ fontSize: 14, color: "#03a99f" }}>
								<strong>Telefono: </strong>
								{userData.phone}
							</p>
							<p style={{ fontSize: 14, color: "#03a99f" }}>
								<strong>Email: </strong>
								{userData.email}
							</p>
							<span
								style={{ color: "#001439", fontSize: 16, fontWeight: "bold" }}
							>
								Formacion Profesional
							</span>
							<form onSubmit={create} name="expert_form">
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={tr_ele_dom}
										onChange={e => setTrEleDom(e.target.checked)}
									/>{" "}
									Tecnico Electrico Domiciliario
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={tr_ele_ind}
										onChange={e => setTrEleInd(e.target.checked)}
									/>{" "}
									Tecnico Electrico Industrial
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={tr_air_aco}
										onChange={e => setTrAirAco(e.target.checked)}
									/>{" "}
									Tecnico en Aires Acondicionados
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={tr_ref_ind}
										onChange={e => setTrRefInd(e.target.checked)}
									/>{" "}
									Tecnico en Refrigeracion Industrial
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={tr_mec_aut}
										onChange={e => setTrMecAut(e.target.checked)}
									/>{" "}
									Tecnico en Mecanica Automotriz
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={tr_ele_aut}
										onChange={e => setTrEleAut(e.target.checked)}
									/>{" "}
									Tecnico en Electricidad Automotriz
								</p>
								<span
									style={{
										color: "#001439",
										fontSize: 16,
										fontWeight: "bold"
									}}
								>
									Recibir Solicitudes de Servicios de:
								</span>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={request_s_air}
										onChange={e => setRequestSAir(e.target.checked)}
									/>{" "}
									Refrigeracion y Aires Acondicionados
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={request_s_ele}
										onChange={e => setRequestSEle(e.target.checked)}
									/>{" "}
									Electricidad
								</p>
								<p style={{ fontSize: 12, color: "#03a99f" }}>
									<input
										type="checkbox"
										checked={request_s_mcn}
										onChange={e => setRequestSMcn(e.target.checked)}
									/>{" "}
									Mecanica
								</p>
								<br />
								<span
									style={{ fontSize: 14, fontWeight: "bold", color: "#001439" }}
								>
									<input
										type="checkbox"
										checked={termsAccepted}
										onChange={e => setTermsAccepted(e.target.checked)}
									/>
									He leído y acepto los{" "}
									<a
										href="https://tiluchi-service.web.app/PoliciesExperts"
										target="_blank"
										rel="noopener noreferrer"
									>
										términos y condiciones
									</a>
								</span>
								<span
									style={{
										fontSize: 10,
										color: "#03a99f",
										textAlign: "left"
									}}
								>
									* Estos terminos y condiciones son diferentes a los que
									aceptaste al crear tu cuenta de usuario.
								</span>
								<br />
								<button type="submit" style={{ backgroundColor: "#001439" }}>
									<span style={{ color: "white", fontSize: 16 }}>
										Crear Perfil Profesional
									</span>
								</button>
							</form>
						</div>
						<br />
						<button
							onClick={() => navigate("/")}
							style={{ backgroundColor: "#001439" }}
						>
							<span style={{ color: "white", fontSize: 16 }}>Atras</span>
						</button>
					</div>}
		</div>
	);
}

export default ModePro;
